import { IGetQueryStateValuesProps } from './types';

export const getFilterValue = <T>({
  accessorKey,
  queryState,
}: IGetQueryStateValuesProps) =>
  queryState.columnFilters?.find(filter => filter.id === accessorKey)
    ?.value as T;
